import { Injectable, EventEmitter, Output } from "@angular/core";
export var NgxMsgService = (function () {
    function NgxMsgService() {
        this.newMessage = new EventEmitter();
    }
    NgxMsgService.prototype.message = function (msg) {
        this.newMessage.emit(msg);
    };
    NgxMsgService.decorators = [
        { type: Injectable },
    ];
    NgxMsgService.ctorParameters = [];
    NgxMsgService.propDecorators = {
        'newMessage': [{ type: Output },],
    };
    return NgxMsgService;
}());
//# sourceMappingURL=ngx-msg.service.js.map